import { FileValue } from '@comparaonline/ui-form-fields-next';
import { Validator } from '@comparaonline/ui-forms-validators/dist/types/Validator';
import { errorCode } from '@comparaonline/ui-forms-validators/dist/validators/commons/required';

const requiredAttributes: (keyof FileValue)[] = ['uploadDate', 'uploadUrl', 'fileName'];

export const requiredFile: Validator<FileValue> = fileValue => {
  if (!fileValue) {
    return { errorCode };
  }

  const fileValueAttributes = Object.keys(fileValue);
  const isFullFileValue = requiredAttributes.every(requiredAttribute =>
    fileValueAttributes.some(
      attribute => requiredAttribute === attribute && Boolean(fileValue[attribute])
    )
  );
  return isFullFileValue ? undefined : { errorCode };
};
